<div class="container-fluid edit-page">
    <div class="row justify-content-center">
        <div class="col-lg-8 col-md-10 pr-0 pl-0">
            <div class="card">
                <div class="card-body">
                    <!-- HEADER -->
                    <div class="tw:!my-6 tw:flex tw:items-center tw:justify-between">
                        <div class="tw:flex tw:cursor-pointer tw:gap-4">
                            <h3 class="tw:!font-extrabold color-primary tw:!text-base tw:md:!text-2xl tw:py-2 tw:!mb-0 opacity-50" routerLink="../">{{ 'SALES_LIST_PAGE.sales' | translate }}</h3>
                            <h3 class="tw:!font-extrabold color-primary tw:!text-base tw:md:!text-2xl tw:py-2 tw:!mb-0 opacity-50" routerLink="../payments">
                                {{ 'SALES_LIST_PAGE.payments' | translate }}
                            </h3>
                            <h3 class="tw:!font-extrabold color-primary tw:!text-base tw:md:!text-2xl tw:py-2 tw:!mb-0">
                                {{ 'SALES_LIST_PAGE.commissions' | translate }}
                            </h3>
                        </div>
                    </div>

                    <form
                        [formGroup]="searchForm"
                        class="tw:flex tw:flex-col tw:items-center tw:gap-4 tw:md:flex-row tw:mb-6"
                        [class.opacity-50]="loading()"
                        [class.pointer-events-none]="loading()"
                    >
                        <div class="tw:flex tw:gap-4">
                            <div dropdown container="body" placement="bottom left">
                                <button dropdownToggle class="btn btn-md btn-secondary" type="button">
                                    @if (selectedDateRange().value === 'custom') {
                                        {{ searchForm.value.startDate | date: 'shortDate' }} - {{ searchForm.value.endDate | date: 'shortDate' }}
                                    } @else {
                                        {{ selectedDateRange().label }}
                                    }

                                    <i class="material-icons icon">arrow_drop_down</i>
                                </button>
                                <ul *dropdownMenu class="dropdown-menu">
                                    @for (range of filterDateRanges; let i = $index; track i) {
                                        <li>
                                            <a class="dropdown-item" (click)="setDateRange(range)">
                                                {{ range.label }}
                                            </a>
                                        </li>
                                    }
                                </ul>
                            </div>

                            @if (currentUser()?.role !== 'provider' && availableProviders()?.length > 1) {
                                <div dropdown container="body" placement="bottom left">
                                    <button dropdownToggle class="btn btn-md btn-secondary" type="button">
                                        {{ searchForm.value?.provider?.name || ('SALES_LIST_PAGE.allUsers' | translate) }}
                                        <i class="material-icons icon">group</i>
                                    </button>
                                    <ul *dropdownMenu class="dropdown-menu">
                                        <li>
                                            <a class="dropdown-item" (click)="setProviderFilter(null)">
                                                {{ 'SALES_LIST_PAGE.allUsers' | translate }}
                                            </a>
                                        </li>
                                        @for (provider of availableProviders(); let i = $index; track i) {
                                            <li>
                                                <a class="dropdown-item" (click)="setProviderFilter(provider)">
                                                    {{ provider.name }}
                                                </a>
                                            </li>
                                        }
                                    </ul>
                                </div>
                            }

                            <div dropdown container="body" placement="bottom left">
                                <button dropdownToggle class="btn btn-md btn-secondary" type="button">
                                    {{ searchForm.value?.status?.label || ('SALES_LIST_PAGE.state' | translate) }}
                                    <i class="material-icons icon">arrow_drop_down</i>
                                </button>
                                <ul *dropdownMenu class="dropdown-menu">
                                    <li>
                                        <a class="dropdown-item" (click)="setSaleStatus(null)">
                                            {{ 'GENERAL.all' | translate }}
                                        </a>
                                    </li>
                                    @for (status of saleStatuses; let i = $index; track i) {
                                        <li>
                                            <a class="dropdown-item" (click)="setSaleStatus(status)">
                                                {{ status.label }}
                                            </a>
                                        </li>
                                    }
                                </ul>
                            </div>
                        </div>
                    </form>

                    @if (loading()) {
                        <app-loader />
                    } @else {
                        <!-- TOTALS  -->
                        @if (commissionsData().commissions.length > 0) {
                            <div class="tw:mb-4 tw:flex tw:justify-between tw:gap-4 tw:rounded-lg tw:bg-primary-50 tw:p-4">
                                <div class="tw:font-semibold">
                                    {{ commissionsData().summary.totalPayments }} {{ 'SALES_LIST_PAGE.paymentsCount' | translate }}
                                </div>
                                <div class="tw:font-semibold">
                                    <span class="tw:text-neutral-500">{{ 'COMMISSIONS_LIST_PAGE.totalCommission' | translate }}: </span>
                                    <span>{{ commissionsData().summary.totalCommission | merchantCurrency }}</span>
                                </div>
                            </div>
                        }

                        <!-- EMPTY STATE -->
                        @if (commissionsData().commissions.length === 0) {
                            <!-- Empty satate -->
                            <div class="empty-state">
                                <div class="text-center">
                                <div class="tw:rounded-full tw:w-12 tw:h-12 tw:bg-primary-50 tw:flex tw:items-center tw:justify-center tw:mx-auto mb-3">
                                    <i class="material-icons tw:text-primary-300">view_list</i>
                                </div>
                                <p class="text-secondary tw:mb-3">{{ 'COMMISSIONS_LIST_PAGE.emptyState.description' | translate }}</p>
                                </div>
                            </div>
                        } @else {
                            <!-- TABLE  -->
                            <div class="tw:w-full tw:overflow-x-auto">
                                <div class="tw:table tw:table-auto tw:w-full tw:min-w-[640px]">
                                    <div class="tw:table-header-group">
                                        <div class="tw:table-row tw:bg-primary-50 tw:text-xs tw:font-semibold tw:text-neutral-500 tw:shadow-menu">
                                            <div class="tw:table-cell tw:p-2">{{ 'GENERAL.date' | translate }}</div>
                                            <div class="tw:table-cell tw:p-2">{{ 'COMMISSIONS_LIST_PAGE.sale' | translate }}</div>
                                            <div class="tw:table-cell tw:p-2">{{ 'GENERAL.state' | translate }}</div>
                                            <div class="tw:table-cell tw:p-2">{{ 'COMMISSIONS_LIST_PAGE.nameVat' | translate }}</div>
                                            <div class="tw:table-cell tw:p-2">{{ 'SHARED.userRoles.provider' | translate }}</div>
                                            <div class="tw:table-cell tw:p-2">{{ 'COMMISSIONS_LIST_PAGE.serviceProduct' | translate }}</div>
                                            <div class="tw:table-cell tw:p-2">{{ 'COMMISSIONS_LIST_PAGE.totalWithVat' | translate }}</div>
                                            <div class="tw:table-cell tw:p-2 tw:text-right">
                                                {{ 'COMMISSIONS_LIST_PAGE.commissionWithVat' | translate }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="tw:table-row-group tw:py-2 tw:text-xs tw:text-neutral-500">
                                        @for (line of commissionsData().commissions; let i = $index; track i) {
                                            <div class="tw:table-row tw:shadow-menu" [class.bg-primary-50]="i % 2 == 1">
                                                <div class="tw:table-cell tw:p-2">
                                                    <div>{{ line.saleDate | date: 'dd/MM/yyyy' }}</div>
                                                    <div>{{ line.saleDate | date: 'HH:mm' }}</div>
                                                </div>
                                                <div class="tw:table-cell tw:p-2 tw:align-middle">
                                                    <span (click)="seeDetails(line.saleId)" class="tw:text-primary-500 tw:cursor-pointer tw:hover:underline">
                                                        {{ line?.saleInvoiceReference || line?.saleCode || '-' }}
                                                    </span>
                                                </div>
                                                <div class="tw:table-cell tw:p-2 tw:align-middle">
                                                    <app-sales-status [sale]="{ status: line.saleStatus }" />
                                                </div>
                                                <div class="tw:table-cell tw:p-2">
                                                    @if (line?.clientName) {
                                                        <div>{{ line.clientName }}</div>
                                                    } @else {
                                                        <div class="tw:italic tw:text-neutral-400">{{ 'GENERAL.walkInCustomer' | translate }}</div>
                                                    }
                                                    @if (line?.clientVatNumber) {
                                                        <div>{{ line.clientVatNumber }}</div>
                                                    }
                                                </div>
                                                <div class="tw:table-cell tw:p-2 tw:align-middle">{{ line?.providerName || '-' }}</div>
                                                <div class="tw:table-cell tw:p-2 tw:align-middle">{{ line.serviceName || '-' }}</div>
                                                <div class="tw:table-cell tw:p-2 tw:align-middle">{{ line.serviceTotal | merchantCurrency }}</div>
                                                <div class="tw:table-cell tw:p-2 tw:align-middle tw:font-semibold tw:text-neutral-800">
                                                    <div class="tw:flex tw:items-center tw:justify-end tw:gap-2 whitespace-nowrap">
                                                        {{ line.commissionAmount | merchantCurrency }}
                                                        @if (line.commissionType === 'percentage') {
                                                            ({{ line.commissionValue }}%)
                                                        }
                                                        <app-button size="sm" type="transparent" extraClass="tw:!p-0" (clickEvent)="editCommission(line)">
                                                            <app-icon icon="edit" extraClass="tw:text-primary-400 tw:!text-base" />
                                                        </app-button>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    }
                </div>
            </div>
        </div>
    </div>
</div>
